import request from '@/router/axios';

/**
 * 获取大数据列表
 * @param { Number } current 页数 
 * @param { Number } size 每页条数
 * @param { Object } search 搜索条件
 * @param { String } search.name 姓名
 * @param { String } search.operatorName 操作人姓名
 * @returns 
 */
export const getBigDataList = (current = 1, size = 10, search = {}) => {
  return request({
    url: '/api/blade-bigdataPdfGeneratorRecord/bigdataPdfGeneratorRecord/pageQueryManualInputData',
    method: 'post',
    data: {
      ...search,
      current,
      size
    }
  })
}

/**
 * 新增大数据查询
 * @param { Object } data
 * @param { String } data.name 姓名
 * @param { String } data.phoneNumber 手机号
 * @param { String } data.idNumber 身份证号
 * @returns 
 */
export const add = (data) => {
  return request({
    url: '/api/blade-bigdataPdfGeneratorRecord/bigdataPdfGeneratorRecord/save-manual-input-and-generate',
    method: 'post',
    data: {
      ...data
    }
  })
}